import { Select } from "@its-engineering-and-development/ui-foundation/components";
import { cx } from "@its-engineering-and-development/ui-foundation/utils";

export interface DashboardCardSelectOption {
    id: string;
    label: string;
}

export interface DashboardCardSelectProps {
    label: string;
    selectedKey: string;
    options: DashboardCardSelectOption[];
    onSelectionChange: (key: string) => void;
    className?: string;
}

const SELECT_FIELD_CLASS =
    "w-full [&_button]:!h-11 [&_button]:!w-full [&_button]:!justify-between [&_button]:!rounded-lg [&_button]:!border [&_button]:!border-gray-300 [&_button]:!px-3 [&_button]:!text-sm [&_button]:!font-normal [&_button]:!shadow-none";

/** Full-width select used below dashboard card titles. */
export function DashboardCardSelect({ label, selectedKey, options, onSelectionChange, className }: DashboardCardSelectProps) {
    return (
        <div className={cx("w-full [&_label]:sr-only", className)}>
            <Select label={label} selectedKey={selectedKey} onSelectionChange={(key) => onSelectionChange(String(key))} className={SELECT_FIELD_CLASS}>
                {options.map((option) => (
                    <Select.Item key={option.id} id={option.id}>
                        {option.label}
                    </Select.Item>
                ))}
            </Select>
        </div>
    );
}
